<template>
    <div class="my-6">
        <div
            class="bg-yellow-50 border-l-4 border-yellow-400 p-4"
        >
            <div class="flex">
                <div class="flex-shrink-0">
                    <svg
                        class="h-5 w-5 text-yellow-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </div>

                <div class="ml-3">
                    <p
                        class="font-medium-- text-yellow-700 text-sm md:text-base"
                    >
                        {{ errorMessage[messageKey] }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "VehicleErrorCard",
    props: {
        messageKey: {
            type: String,
            default: 'error',
        },
    },
    data() {
        return {
            // using errorMessage object so we can look through the vehicle.otherVehicleError array and render the correct keys accordingly
            errorMessage: {
                'overTwoHundredThousandMiles': 'Unfortunately, we cannot offer breakdown cover for vehicles over 200,000 miles. If you believe this information is incorrect, please contact our support team and we will be happy to check.',
            }
            
        }
    },

};
</script>

<style scoped></style>
